import { render, staticRenderFns } from "./fourQuadrants.vue?vue&type=template&id=42bfc857&"
import script from "./fourQuadrants.vue?vue&type=script&lang=js&"
export * from "./fourQuadrants.vue?vue&type=script&lang=js&"
import style0 from "./fourQuadrants.vue?vue&type=style&index=0&id=42bfc857&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports